import i18n from 'i18next';

//message d'erreur
export let EmptyErrorMessages = {
  civilite: i18n.t('cheminapi_error_empty_civilite'),
  nom: i18n.t('cheminapi_error_empty_nom'),
  prenom: i18n.t('cheminapi_error_empty_prenom'),
  date_naissance: i18n.t('cheminapi_error_empty_date_naissance'),
  mail: i18n.t('cheminapi_error_empty_mail'),
  mail_confirm: i18n.t('cheminapi_error_empty_mail_confirm'),
  adresse: i18n.t('cheminapi_error_empty_adresse'),
  cp: i18n.t('cheminapi_error_empty_cp'),
  ville: i18n.t('cheminapi_error_empty_ville'),
  optin_reglement: i18n.t('cheminapi_error_empty_optin_reglement'),
  optin_consent: i18n.t('cheminapi_error_empty_optin_consent'),
  optin_age: i18n.t('cheminapi_error_empty_optin_age'),
  recaptcha: i18n.t('cheminapi_error_empty_recaptcha'),
  code_unique: i18n.t('cheminapi_error_empty_code_unique'),
  code_unique2: i18n.t('cheminapi_error_empty_code_unique2'),
  telephone: i18n.t('cheminapi_error_empty_telephone'),
  ticket: i18n.t('cheminapi_error_empty_ticket'),
  password: i18n.t('cheminapi_error_empty_password'),
  generic: i18n.t('cheminapi_error_empty_generic')
};

export let InvalidErrorMessages = {
  nom: i18n.t('cheminapi_error_invalid_nom'),
  prenom: i18n.t('cheminapi_error_invalid_prenom'),
  date_naissance_age: i18n.t('cheminapi_error_invalid_date_naissance_age'),
  adresse: i18n.t('cheminapi_error_invalid_adresse'),
  cp: i18n.t('cheminapi_error_invalid_cp'),
  ville: i18n.t('cheminapi_error_invalid_ville'),
  telephone: i18n.t('cheminapi_error_invalid_telephone'),
  mail: i18n.t('cheminapi_error_invalid_mail'),
  mail_dif: i18n.t('cheminapi_error_invalid_mail_dif'),
  optin_age: i18n.t('cheminapi_error_invalid_optin_age'),
  password: i18n.t('cheminapi_error_invalid_password'),
  mail_domain: i18n.t('cheminapi_error_invalid_mail_domain')
};

//--------------------
//case 'tous' cochée
//--------------------
export function checkAllRgpdBox(event) {
  let parent = event.target.closest('.rgpd_checkbox_wrapper');
  let childs = parent.querySelectorAll('input[type="checkbox"]:not(.checkbox_all)');
  let all = parent.querySelector('.checkbox_all');

  childs.forEach(child => {
    child.checked = all.checked;
  });

}

//--------------------
//décochage de la case 'tous' si une autre case est décochée
//--------------------
export function uncheckRgpdAllBox(event) {

  let isCheckedAll = true;
  let parent = event.target.closest('.rgpd_checkbox_wrapper');
  let childs = parent.querySelectorAll('input[type="checkbox"]:not(.checkbox_all)');
  let all = parent.querySelector('.checkbox_all');

  childs.forEach(child => {
    if (!child.checked)
      isCheckedAll = false;
  });

  all.checked = isCheckedAll;
}

//------------------------
//	on change field mail
//------------------------
export function checkMailConfirm() {

  let mail = document.getElementById("mail").value;
  let mail_confirm = document.getElementById("mail_confirm").value;

  //check de la correspondance des deux emails
  if (mail.length !== 0 && mail_confirm.length !== 0 && mail !== mail_confirm)
    return false;

  return true;
}

export function checkMailDomain(value) {

  let domain = value.substring(value.indexOf('@') + 1);
  let forbiddenMailDomain = [
    'yopmail.com',
    'clipmail.eu',
    'clrmail.com',
    'get2mail.fr',
    'mail-temporaire.fr',
    'spamfree24.org',
    'jetable.org',
    'lala.fr'];

  //check de l'extension du mail
  return (!forbiddenMailDomain.includes(domain));
}

//------------------------
//	controle age participant
//------------------------
export function checkBirthDate() {

  let day = document.getElementById("jour_naissance").value;
  let month = document.getElementById("mois_naissance").value;
  let year = document.getElementById("annee_naissance").value;

  if (day.length !== 0 && month.length !== 0 && year.length !== 0) {

    let birthday = new Date(year, month - 1, day);

    let ageDifMs = Date.now() - birthday.getTime();
    let ageDate = new Date(ageDifMs);
    let diffYears = Math.abs(ageDate.getUTCFullYear() - 1970);

    console.log(diffYears);

    if (diffYears < 18) {
      return false;
    }
  }

  return true;
}

//------------------------
//	controle du numéro de tel
//------------------------
export function checkTelNumber(value) {

  let valid = true;

  value = value.replace('+33', '0');

  if (!/^[0-9 ]+$/.test(value))
    valid = false;

  if (value.charAt(0) !== '0')
    valid = false;

  if (value === '0000000000')
    valid = false;

  if (value.length !== 10)
    valid = false;

  return valid;
}

//------------------------
//	Password
//------------------------
export function checkPasswordStrenght(password) {

  /*console.log(/\d/.test(password));
  console.log(password.length);*/

  if (password.length == 0)
    return true;

  return /\d/.test(password) && (password.length >= 6);
}

export function checkPasswordConfirm() {
  let password = document.getElementById("mot_de_passe").value;
  let password_confirm = document.getElementById("mot_de_passe_confirm").value;

  //check de la correspondance des deux emails
  if (password.length !== 0 && password_confirm.length !== 0 && password !== password_confirm)
    return false;

  return true;
}

//------------------------
//	controle du fichier avant upload
//------------------------
export function checkIsUploadable(fileToUpload) {

  //check des extensions
  let validExtensions = [
    'jpg',
    'jpeg',
    'png',
    'pdf'];
  let extension = fileToUpload.name.substr(fileToUpload.name.lastIndexOf(".") + 1).toLowerCase();
  let file_size = fileToUpload.size;
  let max_size = 5 * 1024 * 1024;

  if (!validExtensions.includes(extension) || file_size > max_size) {
    return false;
  }

  return true;
}
